// this is used by ccsms and ccs enrolments

import React from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors } from '@myxplor/forms'

import './merge.css'

const content = (status, name) => {
  switch (status) {
  case 'pending':
    return <Loading>Merging {name}</Loading>
  case 'failed':
    return <FormDisplayErrors errors={['Failed to merge ' + name]} />

  default:
    return null
  }
}

const Merge = ({ status, name }) => <div className="merge--wrapper">{content(status, name)}</div>

export default Merge



// WEBPACK FOOTER //
// ./src/care-enrolments/details/merge/index.jsx